export default __webpack_public_path__ + "static/media/AuthorizedSignature-ZVOMx.7ab23119.ttf";